import { Point } from "../component/viewer/Point";

export interface Rectangle {
  x: number;
  y: number;
  width: number;
  height: number;
}

export function isRectangleTooSmall(rectangle: Rectangle): boolean {
  return Math.min(rectangle.width, rectangle.height) < 20;
}

export function isInsideRectangle(rectangle: Rectangle, coords: Point) {
  if (
    rectangle.x < coords.x &&
    coords.x < rectangle.x + rectangle.width &&
    rectangle.y < coords.y &&
    coords.y < rectangle.y + rectangle.height
  ) {
    return true;
  }
  return false;
}
